import styled from "@emotion/styled";

const Label = styled.label<{ dark?: boolean }>`
  color: ${(props) =>
    props.dark ? "var(--dark-indigo)" : "var(--bluey-grey)"};
`;
export default Label;
